export default "__VITE_ASSET__q8tlDy8h__"